import React from "react";

function Icon(props: { className: string }) {
  return (
    <svg className={props.className} viewBox="0 0 19.401 19.35">
      <defs>
        <clipPath>
          <rect
            data-name="Rectangle 9910"
            width="10.914"
            height="10.789"
            transform="translate(0 0)"
            fill="#212f34"
          />
        </clipPath>
      </defs>
      <g>
        <g transform="translate(0 0)">
          <path
            d="M.054,8.823A8.835,8.835,0,0,1,17.523,6.966a.845.845,0,0,1-1.631.436,12.128,12.128,0,0,0-.582-1.663,6.954,6.954,0,0,0-5.5-3.973A7.133,7.133,0,0,0,6.2,15.449c.392.159.808.26,1.215.383a.835.835,0,0,1,.633.861.8.8,0,0,1-.681.778,1.653,1.653,0,0,1-.655-.073A8.742,8.742,0,0,1,.3,10.828a18.011,18.011,0,0,1-.3-2l.054-.008"
            transform="translate(0 0)"
            fill="#222f34"
          />
          <path
            d="M92.378,61.142V59.133q0-1.074,0-2.148a.845.845,0,1,1,1.688-.01c.005.624,0,1.248,0,1.872q0,1.507,0,3.015a.874.874,0,0,1-.968.978c-1.07,0-2.141,0-3.211,0a.847.847,0,0,1-.82-1.14.829.829,0,0,1,.787-.548c.8,0,1.6,0,2.4,0,.032,0,.063,0,.119-.007"
            transform="translate(-84.328 -53.152)"
            fill="#222f34"
          />
        </g>
      </g>
      <g transform="translate(21.987 8.56)">
        <g transform="translate(-13.5 0)" clip-path="url(#clip-path)">
          <path
            d="M9.133,1.512A5.28,5.28,0,0,0,4.367.116,5.1,5.1,0,0,0,.221,3.955,5.075,5.075,0,0,0,1.853,9.412a5.116,5.116,0,0,0,5.617.924,5.124,5.124,0,0,0,3.189-3.817c.134-.593-.059-.935-.5-.994-.53-.071-.727.261-.811.71,0,.018,0,.037-.008.055A3.913,3.913,0,0,1,6.3,9.306,3.817,3.817,0,0,1,2.26,7.919,3.846,3.846,0,0,1,1.7,3.732a3.974,3.974,0,0,1,6.41-1.269,5.351,5.351,0,0,0-.554.461c-.341.367-.248.712.226.819.868.2,1.74.375,2.613.548.348.069.571-.09.506-.454-.168-.93-.354-1.858-.567-2.78-.093-.4-.385-.436-.673-.186a5.14,5.14,0,0,0-.531.641m-1.7,4.643a.875.875,0,0,0-.767-.939.714.714,0,0,1-.594-.881,6.393,6.393,0,0,0,0-1.225.664.664,0,0,0-.7-.66.612.612,0,0,0-.651.678c0,.762-.025,1.525.016,2.285a.811.811,0,0,0,.349.569,8.928,8.928,0,0,0,1.417.637.656.656,0,0,0,.922-.464"
            transform="translate(-0.001 0)"
            fill="#212f34"
          />
          <path
            d="M9.132,1.512A5.158,5.158,0,0,1,9.663.872c.287-.25.58-.216.673.186.212.921.4,1.849.567,2.779.066.364-.157.523-.506.454-.873-.173-1.745-.351-2.613-.548-.475-.108-.568-.452-.226-.819a5.351,5.351,0,0,1,.554-.461A3.974,3.974,0,0,0,1.7,3.732a3.846,3.846,0,0,0,.557,4.187A3.817,3.817,0,0,0,6.3,9.306,3.913,3.913,0,0,0,9.334,6.29c0-.018,0-.037.008-.055.085-.449.282-.781.811-.71.445.059.638.4.5.994a5.125,5.125,0,0,1-3.189,3.817,5.116,5.116,0,0,1-5.617-.924A5.075,5.075,0,0,1,.22,3.955,5.1,5.1,0,0,1,4.366.116a5.28,5.28,0,0,1,4.766,1.4"
            transform="translate(0 0)"
            fill="#212f34"
          />
          <path
            d="M44.772,25.526a.656.656,0,0,1-.922.464,8.929,8.929,0,0,1-1.417-.637.811.811,0,0,1-.349-.569c-.041-.76-.02-1.523-.016-2.285a.612.612,0,0,1,.651-.678.664.664,0,0,1,.7.66,6.393,6.393,0,0,1,0,1.225.714.714,0,0,0,.594.881.875.875,0,0,1,.767.939"
            transform="translate(-37.336 -19.371)"
            fill="#212f34"
          />
        </g>
      </g>
    </svg>
  );
}

export { Icon };
